import styled from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';
import Title from '../Title';

const S = {};

S.VoteCount = styled.button`
  color: ${palette('colorBody')};
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}rem` : '1.7rem')};
  background: none;
  border: none;
  position: relative;
  margin: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

S.VoteBadge = styled.div`
  background-color: ${palette('primary')};
  color: white;
  border-radius: ${theme('borderRadius.xs')};
  width: 1.2rem;
  font-size: 0.7rem;
  position: absolute;
  top: 3px;
  right: -4px;
`;

S.Container = styled.div`
  position: relative;
  padding: ${theme('spacing.lg')};
  padding-bottom: ${theme('spacing.xl')};
  box-shadow: ${theme('shadow.sm')};
  ${theme('components.StepBar.Container')}
`;

S.Title = styled(Title)`
  line-height: 1.2;
  margin-bottom: 10px;
  padding-right: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

S.Step = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: ${ifProp(
    'accomplished',
    palette('colorStepbarLineActive'),
    palette('colorStepbarLine')
  )};
  transition: ${theme('transition')};
`;

S.StepLabel = styled.div`
  position: absolute;
  top: 26px;
  font-weight: ${theme('fontWeight.bold')};
  font-size: ${theme('fontSize.sm')};
  color: ${ifProp(
    'accomplished',
    palette('colorStepbarLineActive'),
    palette('colorStepbarLine')
  )};
  ${theme('components.StepBar.StepLabel')}
`;

S.WrapProgress = styled.div`
  width: 100%;
`;

S.TooltipContent = styled.div`
  max-width: 150px;
  line-height: 1.5;
  font-size: ${theme('fontSize.xxs')};
`;

export default S;
